import ModalContentWrapper from "root/Modals/ModalContentWrapper";
import {Fragment} from "react";
import {ModalLunchReportModes} from "root/s360components/Modals/LunchReport/useModalLunchReport";

const ModalLunchReport = ({mode, error, message}) =>
{

    const successResponse = () =>
    {
        return (
            <h2>Lunch Report Complete</h2>
        )
    }

    const validationResponse = () =>
    {
        return (
            <Fragment>
                <h2>Lunch Report</h2>
                <p>{message}</p>
            </Fragment>
        )
    }

    const errorResponse = () =>
    {
        return (
            <Fragment>
                <h2>Lunch report - Fatal Error</h2>
                <p style={{color: "red"}}>{message}</p>
                <p>{JSON.stringify(error)}</p>
            </Fragment>
        )
    }


    return (
        <ModalContentWrapper>
            <div>
                {mode === ModalLunchReportModes.VIEW && successResponse()}
                {mode === ModalLunchReportModes.VALIDATE && validationResponse()}
                {mode === ModalLunchReportModes.ERROR && errorResponse()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalLunchReport;